import React, { useEffect, useState } from 'react';
import { Modal } from '@ofself/shell';
import { useAuth } from '../../contexts/AuthContext';
import api from '../../services/api';
import { SheetFoot, FootButton } from './SheetFoot';
import './ProfileGate.css';

// EVERYONE HAS A PROFILE. Sign-up makes one and makes it the default
// (routes/auth.py), and the last one cannot be deleted (DELETE /nodes). An
// account from before that, with none, is asked for one before anything else;
// one with profiles but no default gets its first as the default, so a realm, a
// contract and the consent page always have someone to show.
export default function ProfileGate() {
    const { user, refreshUser } = useAuth() || {};
    const [need, setNeed] = useState(false);
    const [name, setName] = useState('');
    const [busy, setBusy] = useState(false);
    const [err, setErr] = useState(null);
    const userId = user?.id;
    const hasDefault = !!user?.default_profile_node_id;

    useEffect(() => {
        if (!userId || hasDefault) return undefined;
        let live = true;
        Promise.resolve(api.getNodes({ schema_id: 'profile', limit: 5 })).then(async (r) => {
            const list = Array.isArray(r) ? r : r?.nodes || [];
            if (!live) return;
            if (!list.length) { setName(user?.first_name || user?.username || ''); setNeed(true); return; }
            try { await api.updateUser(userId, { default_profile_node_id: list[0].id }); refreshUser?.(); } catch { /* the editor still falls back to the first */ }
        }).catch(() => {});
        return () => { live = false; };
    }, [userId, hasDefault]); // eslint-disable-line react-hooks/exhaustive-deps

    if (!need) return null;
    const make = async () => {
        const title = name.trim();
        if (!title || busy) return;
        setBusy(true); setErr(null);
        try {
            const n = await api.request('/nodes', { method: 'POST', body: { title, value_json: { display_name: title }, schema_name: 'profile' } });
            const node = n?.node || n;
            await api.updateUser(userId, { default_profile_node_id: node.id });
            refreshUser?.();
            setNeed(false);
        } catch (e) { setErr(e?.message || 'Could not make it'); }
        setBusy(false);
    };
    return (
        <Modal label="Make your profile" closeButton={false} onClose={() => {}} className="nx-pgate">
            <div className="nx-pgate__body">
                <h2>Make your profile</h2>
                <p>It is who apps, people and groups see you as. You can change it, add a photo, and make more identities later in Settings.</p>
                <label className="nx-pgate__field">
                    <span>Your name</span>
                    <input value={name} onChange={(e) => setName(e.target.value)} autoFocus aria-label="Your name"
                        onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); make(); } }} />
                </label>
                {err && <p className="nx-pgate__err">{err}</p>}
                <SheetFoot>
                    <FootButton primary disabled={!name.trim()} busy={busy} onClick={make}>Make my profile</FootButton>
                </SheetFoot>
            </div>
        </Modal>
    );
}
